import styles from "./AngeboteKarte.module.css";
import Griechenland from "../../../assets/docs/Griechenland.pdf";

function AngeboteKarteGR({ title, price, body }) {
  return (
    <div className={styles.angeboteKarteContainer}>
      <p className={styles.countryTitle}>{title}</p>
      <div className={styles.priceContainer}>
        <p className={styles.priceTitle}>ab</p>
        <p className={styles.priceValue}>{price}</p>
      </div>
      <p className={styles.priceDescription}>
        die Preise beziehen sich auf p. P.
      </p>
      <p className={styles.body}>{body}</p>
      <div className={styles.button} role="button">
        <a href={Griechenland} download="Griechenland">
          Hier Menü herunterladen
        </a>
      </div>
    </div>
  );
}

export default AngeboteKarteGR;